export const PILLAR_ID = {
  PROFILE: 'perfil',
  CLINICAL_PROFILE: 'historico',
  CHANNEL: 'channel',
  BUD: 'roteiro',
  TIMELINE: 'timeline',
  WANDA: 'wanda',
  DEMAND: 'casos',
  HEALTH_PLAN: 'pda',
  EXAMS: 'exames',
  EITA: 'eita',
  RISK: 'risco',
  CLINICAL_RECORD: 'registro'
}
